module.exports = __webpack_public_path__ + "image-9e5463d09a14.png";